import { render, staticRenderFns } from "./ContabilitaDocumentoDatiEditCompontent.vue?vue&type=template&id=0bea68f6&scoped=true"
import script from "./ContabilitaDocumentoDatiEditCompontent.vue?vue&type=script&lang=js"
export * from "./ContabilitaDocumentoDatiEditCompontent.vue?vue&type=script&lang=js"
import style0 from "./ContabilitaDocumentoDatiEditCompontent.vue?vue&type=style&index=0&id=0bea68f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bea68f6",
  null
  
)

export default component.exports